export default "__VITE_ASSET__IgXluDjk__"